module.exports = __webpack_public_path__ + "img/004-facebook.b5fcf817.svg";